// Ставка НДС юрлица FAKT; код для платёжного провайдера бэк получает маппингом
export default class VatRate {
  static get None () { return 'none' }
  static get Zero () { return 'zero' }
  static get Five () { return 'five' }
  static get Seven () { return 'seven' }
  static get Ten () { return 'ten' }
  static get Twenty () { return 'twenty' }
  static get TwentyTwo () { return 'twenty_two' }
  static get FiveOfHundredFive () { return 'five_of_hundred_five' }
  static get SevenOfHundredSeven () { return 'seven_of_hundred_seven' }
  static get TenOfHundredTen () { return 'ten_of_hundred_ten' }
  static get TwentyOfHundredTwenty () { return 'twenty_of_hundred_twenty' }
  static get TwentyTwoOfHundredTwentyTwo () { return 'twenty_two_of_hundred_twenty_two' }

  static getName (enumValue) {
    switch (enumValue) {
      case VatRate.None:
        return 'Без НДС'

      case VatRate.Zero:
        return 'НДС 0%'

      case VatRate.Five:
        return 'НДС 5%'

      case VatRate.Seven:
        return 'НДС 7%'

      case VatRate.Ten:
        return 'НДС 10%'

      case VatRate.Twenty:
        return 'НДС 20%'

      case VatRate.TwentyTwo:
        return 'НДС 22%'

      case VatRate.FiveOfHundredFive:
        return 'НДС 5/105'

      case VatRate.SevenOfHundredSeven:
        return 'НДС 7/107'

      case VatRate.TenOfHundredTen:
        return 'НДС 10/110'

      case VatRate.TwentyOfHundredTwenty:
        return 'НДС 20/120'

      case VatRate.TwentyTwoOfHundredTwentyTwo:
        return 'НДС 22/122'

      default:
        return enumValue
    }
  }

  static getAllVariants () {
    const variants = [
      VatRate.None,
      VatRate.Zero,
      VatRate.Five,
      VatRate.Seven,
      VatRate.Ten,
      VatRate.Twenty,
      VatRate.TwentyTwo,
      VatRate.FiveOfHundredFive,
      VatRate.SevenOfHundredSeven,
      VatRate.TenOfHundredTen,
      VatRate.TwentyOfHundredTwenty,
      VatRate.TwentyTwoOfHundredTwentyTwo,
    ]

    return variants.map((item) => ({
      value: item,
      name: VatRate.getName(item),
    }))
  }
}
